import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationDirective } from 'helpers/directives/validation/validation.directive';
import { PermissionDirective } from 'helpers/directives/permission/permission.directive';
import { CustomDisabledDirective } from 'helpers/directives/customdisabled/customdisabled.directive';
import { ValidationNoControlDirective } from 'helpers/directives/validation/validationNoControl.directive';
import { NumericDirective } from './numeric.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  exports:[
    ValidationDirective,
    ValidationNoControlDirective,
    PermissionDirective,
    CustomDisabledDirective,
    NumericDirective
  ],
  declarations: [
    ValidationDirective,
    ValidationNoControlDirective,
    PermissionDirective,
    CustomDisabledDirective,
    NumericDirective
  ]
})
export class DirectivesModule { }



// WEBPACK FOOTER //
// ./src/app/helpers/directives/directives.module.ts